import { gql } from "@apollo/client"

//lambda
export const branchQuery = gql`query branchesByLocationQuery(
    $lat: Float
    $lng: Float
    $distance: Int
    $name: String
    $limit: Int
    $offset: Int
    $forPickup: Boolean
  ) {
    branchesByLocation(
      lat: $lat
      lng: $lng
      distance: $distance
      name: $name
      limit: $limit
      offset: $offset
      forPickup: $forPickup
    ) {
      _id
      name
    }
  }`


//wishlist graph
export const branchQueryII = gql`query branchesByLocationIIQuery(
    $companyId: String,
    $lat: Float
    $lng: Float
    $distance: Int
    $limit: Int
    $egrPickup: Boolean
  ) {
    getBranchesByLocation(
      companyId: $companyId
      lat: $lat
      lng: $lng
      distance: $distance
      limit: $limit
      egrPickup: $egrPickup
    ) {
      _id
      name
    }
  }`